module.exports = __webpack_public_path__ + "static/media/Shop_Gold_TriangleDivider@3x.b235e65b.png";